import { render } from "./UploadDocument.vue?vue&type=template&id=42bf8026"
import script from "./UploadDocument.vue?vue&type=script&lang=js"
export * from "./UploadDocument.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__